import { render, staticRenderFns } from "./GoogleRecaptcha.vue?vue&type=template&id=2cfcc96b&"
import script from "./GoogleRecaptcha.vue?vue&type=script&lang=js&"
export * from "./GoogleRecaptcha.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports